define(function (require) {
    "use strict";

    var BaseFeatureController = require("personalization-controllers/BaseFeatureController");
    var AgentFileSharingAnchorView = require("personalization-web-agent-views/AgentFileSharingAnchorView");
    var SettingsCollection = require("collections/SettingsCollection");

    var Settings = require("codeTables/settings.json");

    var AgentFileSharingAnchorController = {};

    LE.module("LEPersonalization", function (LEPersonalization, LE, Backbone, Marionette, $, _) {

        AgentFileSharingAnchorController = BaseFeatureController.extend({
            initialize: function (options) {
                this._initialize(options);
                this.settingsCollection = new SettingsCollection([], {contextType: Settings.CONTEXT_TYPE.ACCOUNT, contextCascading: true});
                this._getSettingsCollection();
            },


            getAnchorView: function() {
                return this._getAnchorView();
            },

            _initialize: function(options) {
                LEPersonalization.logger.info("initializing", "AgentFileSharingAnchorController:_initialize", options);

                this.featureId = options.featureOptions.id;

                this._createView(options);
                this._bindEvents();
            },

            _createView: function(options) {
                LEPersonalization.logger.debug("create the anchor view", "AgentFileSharingAnchorController:_createView");
                this.agentFileSharingAnchorView = new AgentFileSharingAnchorView({
                    featureId:this.featureId
                });

                LEPersonalization.logger.debug("created anchor view", "AgentFileSharingAnchorController:_createView", this.agentFileSharingAnchorView);
            },

            _bindEvents: function() {
                LEPersonalization.logger.debug("binding events", "AgentFileSharingAnchorController:_bindEvents");
                this.listenTo(this.agentFileSharingAnchorView, "agentFileSharing:navigateToFeatureEdit", this._onNavigateToFeatureEdit);
            },

            _onNavigateToFeatureEdit: function () {
                LEPersonalization.logger.info("navigate to feature edit", "AgentFileSharingAnchorController:_onNavigateToFeatureEdit");
                LEPersonalization.navigateToFeatureEdit({
                    featureId: this.featureId,
                    controllerOptions:{
                        settingsCollection: this.settingsCollection
                    }
                });
            },

            _getAnchorView: function () {
                return this.agentFileSharingAnchorView;
            },

            _onFetchSuccess: function (model, response, options) {
                LEPersonalization.logger.debug("When data fetch was successful", "AgentFileSharingAnchorController:_onFetchSuccess. response = " + response);
                this.agentFileSharingAnchorView.setValues({settingsCollection: this.settingsCollection});
            },

            _onFetchError: function (model, response, options) {
                LEPersonalization.logger.debug("When data fetch has resulted with an error", "AgentFileSharingAnchorController:_onFetchError. response = " + response);
                LEPersonalization.notifier.showError(LE.translator.translate("LEFramework.errors.serverError.1100"));
            },

            _getSettingsCollection: function() {
                LEPersonalization.logger.debug("Retrieve the settings collection", "AgentFileSharingAnchorController:_getSettingsCollection.");
                var settingsOptions = {
                    groups: Settings.SETTING_GROUP.loginSession,
                    success: _.bind(this._onFetchSuccess, this),
                    error: _.bind(this._onFetchError, this)
                };
                this.settingsCollection.fetch(settingsOptions);
            }
        });
    });
    return AgentFileSharingAnchorController;

});
